import { render, staticRenderFns } from "./Cep.vue?vue&type=template&id=5a2f1565&"
import script from "./Cep.vue?vue&type=script&lang=js&"
export * from "./Cep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports